<template>
  <header class="h-16 bg-gradient-to-b from-gray-800 to-gray-900 border-b border-gray-700 flex items-center justify-between px-6 shadow-md relative">
    <h2 class="text-xl font-semibold text-white">{{ pageTitle }}</h2>
    <div class="flex items-center space-x-4">
    <!-- Order Button -->
    <router-link to="/order" class="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-medium transition">
        Deploy
    </router-link>
        
      <!-- Notifications Button -->
      <button @click="toggleNotifications" class="p-2 bg-gray-700 rounded-full hover:bg-blue-500 transition">
        <BellIcon class="w-5 h-5 text-white"/>
      </button>

      <!-- Settings Button -->
      <button @click="moveToSettings" class="p-2 bg-gray-700 rounded-full hover:bg-blue-500 transition">
        <CogIcon class="w-5 h-5 text-white"/>
      </button>

      <!-- Profile Icon (Opens Dropdown) -->
      <div @click="toggleDropdown" class="relative">
        <div class="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold cursor-pointer">
          {{ user.initials }}
        </div>
        <!-- Profile Dropdown -->
        <div v-if="isDropdownOpen"
          class="absolute right-0 mt-2 w-48 bg-gray-800 bg-opacity-90 p-2 rounded-lg shadow-lg z-50">
          <ul class="py-2 text-white">
            <li>
              <router-link to="/settings" class="block px-4 py-2 hover:bg-gray-700 rounded transition" @click="closeDropdown">
                <CogIcon class="w-4 h-4 inline mr-2"/> Settings
              </router-link>
            </li>
            <li>
              <button @click="logout" class="w-full text-left px-4 py-2 text-red-400 hover:bg-gray-700 rounded transition">
                <ArrowRightOnRectangleIcon class="w-4 h-4 inline mr-2"/> Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Notification Popup -->
    <div v-if="showNotifications"
      class="absolute top-16 right-6 bg-gray-800 bg-opacity-90 p-4 rounded-lg shadow-lg w-64 text-white z-50">
      <h3 class="text-lg font-semibold">Notifications</h3>
      <p class="text-sm text-gray-400">No new notifications</p>
    </div>
  </header>
</template>
  
  <script>
  import axios from 'axios';
  import { BellIcon, CogIcon, ArrowRightOnRectangleIcon } from '@heroicons/vue/24/outline';
  
  export default {
    name: 'HeaderVue',
      components: { BellIcon, CogIcon, ArrowRightOnRectangleIcon },
    data() {
      return {
        user: { name: '', initials: '' },
        showNotifications: false,
        isDropdownOpen: false
      };
    },
    computed: {
      pageTitle() {
        const routeTitles = {
          '/dashboard': 'Dashboard',
          '/billing': 'Billing',
          '/settings': 'Settings',
          '/servers': 'Servers',
          '/support': 'Support',
          '/storage': 'Storage',
          '/affiliates': 'Affiliates',
          '/view_ticket': 'Support',
        };
        return routeTitles[this.$route.path] || 'Dashboard';
      }
    },
    methods: {
      async fetchUser() {
        try {
          const response = await axios.get('https://api.syniac.com:3000/api/users/user-initals', { withCredentials: true });
          this.user.name = response.data[0].name;
          this.user.initials = this.user.name.split(' ').map(n => n[0]).join('');
        } catch (error) {
          console.error('Error fetching user:', error);
        }
      },
      moveToSettings() {
        this.$router.push('/settings');
      },
      toggleNotifications() {
        this.showNotifications = !this.showNotifications;
      },
      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },
      closeDropdown() {
        this.isDropdownOpen = false;
      },
      async logout() {
        try {
          this.$router.push('/logout'); 
        } catch (error) {
          console.error('Logout failed:', error);
        }
      }
    },
    mounted() {
      this.fetchUser();
    }
  };
  </script>
  
